export default class BetType {
  static betTypes = {};

  static getBetType = function (code) {
    return BetType.betTypes[code.toLowerCase()];
  };

  hasExtendedGuarantee = () => false;
  hasNumberOfSystems = () => false;
  hasGuaranteePercent = () => true;
  hasSpareType = () => false;
  hasNumberOfFaultingReductionsToTolerate = () => false;
  mayHaveV6 = () => false;
  mayHaveV7 = () => false;
  hasRaceNumber = () => false;
  hasStake = () => false;
  hasJockeyTrainerReduction = () => true;
  hasDividendReduction = () => true;
  hasOwnEvaluationReduction = () => true;
  hasTrendReduction = () => true;

  getNumberOfSystemsOptions = () => [];
  getStakeOptions = () => [];
  getNumberOfFaultingReductionsToTolerateOptions = () => [
    0, 1, 2, 3, 4, 5, 6, 7,
  ];
  getGuaranteePercentOptions = () => {
    const arr = Array.from({ length: 100 }).map(
      (_, idx, arr) => arr.length - idx,
    );

    return arr;
  };
  getSpareTypeOptions = () => ['NEXT_RANKED', 'BEST_RANKED', 'MARK_PERCENT'];
  hasGameSuggestion = () => false;
  hasRaceAnalysis = () => false;
  hasSpares = () => true;
  hasSingleRace = () => false;
  getResetRankingTypes = () => ['percent', 'start-number'];
  getStakeRowsType = () => 'rows';
}

// V75: Antal system (1, 2, 5, 10, 20, 50, 100), Garanti% (0-100), Tolerera förkastningar (0-7), Reservtyp (Nästa rankade, Bäst rankade, Inga)
class BetTypeV75 extends BetType {
  hasNumberOfSystems = () => true;
  getNumberOfSystemsOptions = () => [1, 2, 5, 10, 20, 50, 100];
  hasExtendedGuarantee = () => true;
  hasSpareType = () => true;
  hasNumberOfFaultingReductionsToTolerate = () => true;
  mayHaveV7 = () => true;
  hasGameSuggestion = () => true;
  hasRaceAnalysis = () => true;
}

// GS75: Antal system (1, 2, 5, 10, 20, 50, 100), Garanti% (0-100), Tolerera förkastningar (0-7), Reservtyp (Nästa rankade, Bäst rankade, Inga)
class BetTypeGS75 extends BetTypeV75 {
  mayHaveV7 = () => true;
}

// V86: Antal system (1, 2, 5, 10, 20, 50, 100), Garanti%, Tolerera förkastningar, Reservtyp
class BetTypeV86 extends BetType {
  hasNumberOfSystems = () => true;
  getNumberOfSystemsOptions = () => [1, 2, 5, 10, 20, 50, 100];
  hasExtendedGuarantee = () => true;
  hasSpareType = () => true;
  hasNumberOfFaultingReductionsToTolerate = () => true;
  hasGameSuggestion = () => true;
  hasRaceAnalysis = () => true;
}

// V65: Antal system (1, 2, 3, 4, 5, 10, 50, 100), V6, Garanti%, Tolerera förkastningar, Reservtyp (observera att V6 ska gå att ”checka”)
class BetTypeV65 extends BetType {
  hasNumberOfSystems = () => true;
  getNumberOfSystemsOptions = () => [1, 2, 3, 4, 5, 10, 50, 100];
  hasExtendedGuarantee = () => true;
  hasSpareType = () => true;
  hasNumberOfFaultingReductionsToTolerate = () => true;
  mayHaveV6 = () => true;
}

// V64: Antal system (1, 2, 3, 4, 5, 10, 50, 100), V6, Garanti%, Tolerera förkastningar, Reservtyp (observera att V6 ska gå att ”checka”)
class BetTypeV64 extends BetType {
  hasNumberOfSystems = () => true;
  getNumberOfSystemsOptions = () => [1, 2, 3, 4, 5, 10, 50, 100];
  hasExtendedGuarantee = () => true;
  hasSpareType = () => true;
  hasNumberOfFaultingReductionsToTolerate = () => true;
  mayHaveV6 = () => true;
  hasGameSuggestion = () => true;
  hasRaceAnalysis = () => true;
}

// V5: Antal system (1, 2, 5, 10, 20, 50, 100), Garanti%, Tolerera förkastningar, Reservtyp
class BetTypeV5 extends BetType {
  hasNumberOfSystems = () => true;
  getNumberOfSystemsOptions = () => [1, 2, 5, 10, 20, 50, 100];
  hasSpareType = () => true;
  hasNumberOfFaultingReductionsToTolerate = () => true;
}

// V4: Antal system (1, 2, 3, 4, 5, 10, 50, 100), Garanti%, Tolerera förkastningar, Reservtyp
class BetTypeV4 extends BetType {
  hasNumberOfSystems = () => true;
  getNumberOfSystemsOptions = () => [1, 2, 3, 4, 5, 10, 50, 100];
  hasSpareType = () => true;
  hasNumberOfFaultingReductionsToTolerate = () => true;
}

// V3: Antal system (1, 2, 3, 4, 5, 10, 50, 100), Garanti%, Tolerera förkastningar, Reservtyp
class BetTypeV3 extends BetType {
  hasDividendReduction = () => false;
  hasNumberOfSystems = () => true;
  getNumberOfSystemsOptions = () => [1, 2, 3, 4, 5, 10, 50, 100];
  hasNumberOfFaultingReductionsToTolerate = () => true;
  hasSpares = () => false;
}

// Trio: Loppnr (endast de lopp som har spelformen Trio visas), Insats (2, 5, 10, 20, 30, 40, 50, 100, 200, 500), Garanti%, Tolerera förkastningar, Reservtyp (OBS!, specialfall att välja Loppnr)
class BetTypeTrio extends BetType {
  hasJockeyTrainerReduction = () => false;
  hasOwnEvaluationReduction = () => false;
  hasTrendReduction = () => false;
  hasRaceNumber = () => true;
  hasStake = () => true;
  getStakeOptions = () => [2, 5, 10, 20, 30, 40, 50, 100, 200, 500];
  hasNumberOfFaultingReductionsToTolerate = () => true;
  hasSpares = () => false;
  hasSingleRace = () => true;
  getResetRankingTypes = () => ['odds', 'start-number'];
  getStakeRowsType = () => 'combinations';
}

// DD: Insats (5, 10, 20, 30, 40, 50, 100, 200, 500, 1000), Garanti%, Tolerera förkastningar, Reservtyp
class BetTypeDD extends BetType {
  hasOwnEvaluationReduction = () => false;
  hasTrendReduction = () => false;
  hasStake = () => true;
  getStakeOptions = () => [5, 10, 20, 30, 40, 50, 100, 200, 500, 1000];
  hasNumberOfFaultingReductionsToTolerate = () => true;
  hasSpares = () => false;
  getResetRankingTypes = () => ['odds', 'start-number'];
  getStakeRowsType = () => 'combinations';
}

// LD: Insats (5, 10, 20, 30, 40, 50, 100, 200), Garanti%, Tolerera förkastningar, Reservtyp
class BetTypeLD extends BetType {
  hasOwnEvaluationReduction = () => false;
  hasTrendReduction = () => false;
  hasStake = () => true;
  getStakeOptions = () => [5, 10, 20, 30, 40, 50, 100, 200];
  hasNumberOfFaultingReductionsToTolerate = () => true;
  hasSpares = () => false;
  getResetRankingTypes = () => ['odds', 'start-number'];
  getStakeRowsType = () => 'combinations';
}

// FIVEPLUS: Similar to Trio, but five races and only available in Norway
class BetTypeFivePlus extends BetType {
  hasJockeyTrainerReduction = () => false;
  hasDividendReduction = () => false;
  hasOwnEvaluationReduction = () => false;
  hasTrendReduction = () => false;
  hasRaceNumber = () => true;
  hasStake = () => true;
  getStakeOptions = () => [5, 10, 20];
  hasNumberOfFaultingReductionsToTolerate = () => true;
  hasSpares = () => false;
  hasSingleRace = () => true;
  getResetRankingTypes = () => ['odds', 'start-number'];
  getStakeRowsType = () => 'combinations';
}

BetType.betTypes.v75 = new BetTypeV75();
BetType.betTypes.gs75 = new BetTypeGS75();
BetType.betTypes.v86 = new BetTypeV86();
BetType.betTypes.v65 = new BetTypeV65();
BetType.betTypes.v64 = new BetTypeV64();
BetType.betTypes.v5 = new BetTypeV5();
BetType.betTypes.v4 = new BetTypeV4();
BetType.betTypes.v3 = new BetTypeV3();
BetType.betTypes.t = new BetTypeTrio();
BetType.betTypes.dd = new BetTypeDD();
BetType.betTypes.ld = new BetTypeLD();
BetType.betTypes.fiveplus = new BetTypeFivePlus();
